/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import MenuItem from '@material-ui/core/MenuItem'
import Popover from '@material-ui/core/Popover'
import Snackbar from '@material-ui/core/Snackbar'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Dashboard from '@material-ui/icons/Dashboard'
import ExitToApp from '@material-ui/icons/ExitToApp'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Menu from '@material-ui/icons/Menu'
import MoreVert from '@material-ui/icons/MoreVert'
import Alert from '@material-ui/lab/Alert'
import React, {
  Fragment,
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { Link as LinkRouter, useHistory, useLocation } from 'react-router-dom'

import ColorContext from '../../Context/colorContext'
import {
  clearStorage,
  getImageProfile,
  getUserData as getUserDataRequest,
  getUserDataComplements,
  loginRedirectPrivider,
  logout,
} from '../../services/auth'
import {
  getIcons,
  getLinksHeader,
  getLogos,
  getMenus,
} from '../../services/noticias'
import { UserData } from '../../services/user'
import { cpfMask } from '../../utils/cpfFormat'
import { handleFilter } from '../../utils/handleFilter'
import { getInitialsFromName } from '../../utils/nameFormat'
import Links from '../Links'
import PlayerComponent from '../PlayerComponent'
import { useStyles } from './styles'

const TermoDialog = lazy(() => import('../TermoDialog'))
const ModalAlertsDialog = lazy(() => import('../ModalAlertsDialog'))
const DrawerMenu = lazy(() => import('../DrawerMenu'))
const QuickAccessDrawer = lazy(() => import('../QuickAccessDrawer'))
const AlertDataComplements = lazy(() => import('../AlertDataComplements'))

export interface PropsNavLinks {
  icone: string
  id: number
  slug: string
  titulo: string
  subtopicos: [
    {
      icone: string
      id: number
      slug: string
      titulo: string
    },
  ]
}

interface PropsSubMenu {
  icone: string
  id: string
  link: string
  slug: string
  titulo: string
  link_externo: boolean
  pagina_slug: string
  pagina_publicado: boolean
}

export interface PropsLogos {
  titulo: string
  url_imagem: string
  url: string
  tipo: string
}

export interface PropsLinksHeader {
  ordem: number
  titulo: string
  url: string
  link_externo: boolean
}

export interface PropsIconsHeader {
  ordem: number
  titulo: string
  url_imagem: string
  url: string
}

interface TypeDataComplements {
  id: number
  created_at: string
  data_nascimento: string
  escolaridade: string
  pessoa: string
  profissao: string
  raca: string
  sexo: string
  updated_at: string
  endereco: string
  complemento: string
  bairro: string
  cidade: string
  estado: string
  cep: string
  observacoes: string
  zona: string
  tipo_logradouro: string
  nome_logradouro: string
  numero: string
}

export default function Header(): JSX.Element {
  const { colors, setTypeTheme, typeTheme } = useContext(ColorContext)

  const classes = useStyles({ colors })
  const history = useHistory()
  const location = useLocation()
  const matches = useMediaQuery('(min-width:1200px)')
  const matchesMobile = useMediaQuery('(min-width:660px)')
  const [isPlaying, setIsPlaying] = useState(false)
  const token: string | null = localStorage.getItem('gov_access_token_sso')
  const tokenSiseci: string | null = localStorage.getItem(
    'gov_access_token_siseci',
  )
  const hasComplements = sessionStorage.getItem('@data-complements')
  const [openDrawerNav, setOpenDrawerNav] = useState(false)
  const [openDrawerQuickAccess, setOpenDrawerQuickAccess] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const [anchorElUser, setAnchorElUser] =
    React.useState<HTMLButtonElement | null>(null)
  const [userData, setUserData] = useState<UserData | null>()
  const [message, setMessage] = useState<string>('')
  const [avatarUser, setAvatarUser] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [logoHeader, setLogoHeader] = useState<PropsLogos>()
  const [linksHeader, setLinksHeader] = useState<PropsLinksHeader[]>()
  const [iconsHeader, setIconsHeader] = useState<PropsIconsHeader[]>()
  const [navs, setNavs] = useState<any>([])
  const [openModalComplements, setOpenModalComplements] =
    useState<boolean>(false)
  const [, setDataComplements] = useState<TypeDataComplements>()

  const handlePlayer = () => setIsPlaying(!isPlaying)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function handleSwitchColor() {
    setTypeTheme(typeTheme === 'normal' ? 'contraste' : 'normal')
  }

  async function handleIconsHeader() {
    const { data } = await getIcons()
    setIconsHeader(data)
  }

  async function handleLinkHeaders() {
    const { data } = await getLinksHeader()
    setLinksHeader(data)
  }
  async function handleGetLogos() {
    try {
      const { data } = await getLogos()
      const resultFiltred = handleFilter(data, 'Cabeçalho')

      setLogoHeader(resultFiltred[0])
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }

  useEffect(() => {
    const { state } = location
    if (state as any) {
      setMessage((state as any).message)
    }
  }, [location])

  const getUserData = async (tokenSso: string, tokenSiseciReceive: string) => {
    try {
      setLoading(true)

      const data = await getUserDataRequest(tokenSso, tokenSiseciReceive)

      setUserData(data)
      localStorage.setItem('gov_user_data', JSON.stringify(data))
      // setLoading(false);
    } catch (err) {
      clearStorage()
      if (err.response?.data) {
        setMessage(err.response.data.detail)
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (token && tokenSiseci) {
      getUserData(token, tokenSiseci)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (token && tokenSiseci) {
      getUserData(token, tokenSiseci)
    }
  }, [token, tokenSiseci])

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    type?: 'user' | 'access',
  ) => {
    if (type === 'user') {
      setAnchorElUser(event.currentTarget)
    } else {
      setAnchorEl(event.currentTarget)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleClose = () => {
    setAnchorEl(null)
    setAnchorElUser(null)
  }

  const isWorkspace = location.pathname.startsWith('/workspace')

  const logoutUser = async () => {
    await logout()
    if (isWorkspace) {
      history.push('/')
    }
    setUserData(undefined)
    setAnchorElUser(null)
  }

  useEffect(() => {
    const handleGetImageProfile = async () => {
      if (token) {
        const { data } = await getImageProfile(token)

        if (data?.results?.length > 0) {
          const image = data.results[0].arquivo
          setAvatarUser(image)
        }
      }
    }

    handleGetImageProfile()
  }, [token])

  const preventDefault = (event: React.SyntheticEvent) => event.preventDefault()

  const renderMenus = (): JSX.Element => (
    <>
      {!matches && (
        <>
          <IconButton onClick={handleClick} color="primary">
            <Menu style={{ color: colors.accentColor }} />
          </IconButton>
        </>
      )}
      <Suspense fallback="">
        <TermoDialog />
      </Suspense>
      <Suspense fallback="">
        <ModalAlertsDialog />
      </Suspense>
      {/* <AlertAcceptCookies />  Foi adicionado um script para exibir um modal de cookies no lugar desse. */}
    </>
  )

  const handleVerifyDataComplements = async () => {
    if (token) {
      try {
        const { data } = await getUserDataComplements(token)
        if (data) {
          setDataComplements(data?.results[0])
          sessionStorage.setItem('@data-complements', 'true')
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          sessionStorage.setItem('@data-complements', 'false')
          setOpenModalComplements(true)
        }
      }
    }
  }

  const loginRedirect = () => {
    const urlLocation = location.pathname + location.search
    loginRedirectPrivider(urlLocation)
  }

  const nameSplitOne = (name: string): string => {
    if ((name || '').split(' ').length > 2) {
      return `${name.split(' ')[0]}`
    }
    return name
  }

  const nameSplitTwo = (name: string): string => {
    if ((name || '').split(' ').length > 2) {
      return `${name.split(' ')[0]} ${name.split(' ')[1][0]}.`
    }
    return name
  }

  const handleOpenDrawerMenu = useCallback(() => {
    setOpenDrawerNav((oldDrawer) => !oldDrawer)
  }, [])

  const handleOpenDrawerQuickAccess = useCallback(() => {
    setOpenDrawerQuickAccess((oldDrawer) => !oldDrawer)
  }, [])

  const renderItems = useMemo((): JSX.Element => {
    const menus = [
      {
        titulo: 'Governo',
        url: '',
        external_url: 'https://www.rjdrupal.proderj.rj.gov.br/sobre-governador',
      },
      {
        titulo: 'Cidadão',
        url: '/cidadao/servicos',
      },
      {
        titulo: 'Servidor',
        url: '/servidor/servicos',
      },
      {
        titulo: 'Empresa',
        url: '/empresa/servicos',
      },
      {
        titulo: 'Gestão pública',
        url: '/gestao/servicos',
      },
      {
        titulo: 'Imprensa',
        url: '',
        external_url:
          'https://www.rjdrupal.proderj.rj.gov.br/assessoria-de-imprensa',
      },
      {
        titulo: 'Atendimento',
        url: '',
        external_url:
          'https://falabr.cgu.gov.br/publico/RJ/Manifestacao/RegistrarManifestacao',
      },
      {
        titulo: 'Contraste',
        url: '#',
        click: true,
      },
      {
        titulo: 'Acessibilidade',
        url: '/acessibilidade',
      },
    ]

    return (
      <>
        {menus.map((menu) => (
          <MenuItem
            key={menu.titulo}
            style={{
              backgroundColor: colors.colorBackground,
            }}
          >
            <Link
              color="primary"
              href={menu.url}
              onClick={(e: React.SyntheticEvent): void => {
                preventDefault(e)
                if (menu.external_url) {
                  ;(window as any).open(menu.external_url)
                } else {
                  history.push(menu.url)
                }
                if (menu.click) {
                  handleSwitchColor()
                }
                handleClose()
              }}
              className={classes.text}
            >
              {menu.titulo}
            </Link>
          </MenuItem>
        ))}
      </>
    )
  }, [
    colors.colorBackground,
    classes.text,
    history,
    handleSwitchColor,
    handleClose,
  ])

  const handleFormatLinksMenu = (menuData: PropsSubMenu[]) =>
    menuData.map((menu) => ({
      titulo: menu.titulo,
      url: menu.link,
      isExternal: menu.link_externo,
      pagina_publicado: menu.pagina_publicado || (menu?.link && true),
      pagina_slug: menu.pagina_slug,
      slug: menu.slug,
    }))

  const handleGetHeaderMenus = async () => {
    try {
      const { data } = await getMenus('Cabeçalho')
      if (data?.results) {
        const dynamicNavs = data.results.map((menu: any) => {
          const formattedLinks = menu.submenu_menu
            ? handleFormatLinksMenu(menu.submenu_menu)
            : []

          return {
            nome: menu.titulo,
            list: formattedLinks,
          }
        })

        // Ordenar menus: Governo, Imprensa, Atendimento, e demais
        const orderedNavs = dynamicNavs.sort((a, b) => {
          const order = ['Governo', 'Imprensa', 'Atendimento']
          const indexA = order.indexOf(a.nome)
          const indexB = order.indexOf(b.nome)

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB
          }
          if (indexA !== -1) return -1
          if (indexB !== -1) return 1
          return 0
        })

        setNavs(orderedNavs)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (token && userData && !hasComplements) {
      handleVerifyDataComplements()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, userData])

  useEffect(() => {
    if (hasComplements === 'false') {
      setOpenModalComplements(true)
    }
  }, [hasComplements])

  async function promiseAll() {
    await Promise.all([
      handleGetLogos(),
      handleLinkHeaders(),
      handleIconsHeader(),
      handleGetHeaderMenus(),
    ])
  }

  useEffect(() => {
    promiseAll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Box id="back-to-top-anchor" style={{ top: 0 }} className={classes.main}>
        <Snackbar
          autoHideDuration={3000}
          onClose={(): void => setMessage('')}
          open={!!message}
        >
          <Alert onClose={(): void => setMessage('')} severity="error">
            {message}
          </Alert>
        </Snackbar>
        <Popover
          className={classes.boxInfo}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {renderItems}
        </Popover>
        <Popover
          open={Boolean(anchorElUser)}
          anchorEl={anchorElUser}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Box>
            {userData && (
              <MenuItem
                style={{
                  backgroundColor: colors.colorBackground,
                }}
              >
                <Avatar
                  src={avatarUser || null}
                  alt={getInitialsFromName(userData.nome || '')}
                  className={classes.avatar}
                />
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                >
                  <Typography className={classes.textNamePopOver}>
                    {matchesMobile
                      ? nameSplitTwo(userData?.nome?.toLowerCase())
                      : nameSplitOne(userData?.nome?.toLowerCase())}
                  </Typography>
                  <Typography className={classes.textCpfPopOver}>
                    {cpfMask(userData.cpf)}
                  </Typography>
                </Box>
              </MenuItem>
            )}
            <MenuItem className={classes.menuItem}>
              <a
                href="/workspace"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  textDecoration: 'none',
                  fontFamily: 'Roboto',
                  fontSize: 16,
                  fontWeight: 500,
                }}
              >
                <Dashboard style={{ color: colors.accentColor }} />
                <Typography className={classes.textMenuItem}>Meu RJ</Typography>
              </a>
            </MenuItem>
            {/* <Divider  /> */}
            <MenuItem onClick={logoutUser} className={classes.menuItem}>
              <ExitToApp style={{ color: colors.buttonErrorColor }} />
              <Typography className={classes.textMenuItem}>Sair</Typography>
            </MenuItem>
            {/* <Divider /> */}
          </Box>
        </Popover>
        <Box
          display="flex"
          maxWidth="1320px"
          alignItems="center"
          width="100%"
          justifyContent="space-between"
          flexWrap="wrap"
        >
          <Box width="317px" height="100px">
            {logoHeader?.url_imagem && (
              <a
                href={logoHeader?.url || '/'}
                aria-label="Página inicial - Governo do Estado do Rio de Janeiro"
              >
                <img
                  className={classes.img}
                  width="317px"
                  height="100px"
                  alt="Governo do Estado do Rio de Janeiro"
                  src={logoHeader?.url_imagem}
                  loading="eager"
                  {...{ fetchpriority: 'high' }}
                />
              </a>
            )}
          </Box>
          <Box className={classes.iconQuickAccess}>
            <IconButton
              onClick={() => setOpenDrawerQuickAccess(true)}
              aria-label="Acesso rápido"
            >
              <MoreVert style={{ color: 'white', fontSize: 30 }} />
            </IconButton>
          </Box>
          <Box className={classes.infoHeaderRight}>
            {matches ? (
              <>
                <Box className={classes.linksBoxSubMenu}>
                  <LinkRouter to="/acessibilidade" className={classes.textLink}>
                    ACESSIBILIDADE
                  </LinkRouter>
                  <span className={classes.divider}>|</span>
                  <Button
                    onClick={() => handleSwitchColor()}
                    className={classes.textLink}
                    aria-label="Alternar contraste"
                    style={{ minWidth: 'auto', padding: 0 }}
                  >
                    CONTRASTE
                  </Button>
                  {linksHeader?.length > 0 &&
                    linksHeader.map((link) => (
                      <Fragment key={`${link.titulo}-key`}>
                        <span className={classes.divider}>|</span>
                        <a
                          href={link.url}
                          target={link.link_externo ? '_blank' : '_parent'}
                          className={classes.textLink}
                          rel="noreferrer"
                        >
                          {link.titulo}
                        </a>
                      </Fragment>
                    ))}
                </Box>
              </>
            ) : (
              ''
            )}
          </Box>
        </Box>
      </Box>
      <Box className={classes.navBar}>
        {/* Mobile Navigation */}
        <Box className={classes.navigationMobile}>
          <IconButton
            onClick={() => setOpenDrawerNav(true)}
            size="medium"
            type="button"
            aria-label="Abrir menu de navegação"
          >
            <Menu style={{ fontSize: 40, color: 'white' }} />
          </IconButton>
          <Box display="flex" flex-direction="row" alignItems="center">
            {loading ? (
              <CircularProgress
                style={{ width: 25, height: 25 }}
                color="primary"
              />
            ) : (
              <>
                {userData ? (
                  <Button onClick={(e): void => handleClick(e, 'user')}>
                    <Avatar
                      src={avatarUser || null}
                      alt={getInitialsFromName(userData.nome || '')}
                      className={classes.avatar}
                    />
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                    >
                      <Typography className={classes.textName}>
                        {matchesMobile
                          ? nameSplitTwo(userData?.nome?.toLowerCase())
                          : nameSplitOne(userData?.nome?.toLowerCase())}
                      </Typography>
                      <Typography color="primary" className={classes.textCpf}>
                        {cpfMask(userData.cpf)}
                      </Typography>
                    </Box>
                    <ExpandMore style={{ color: colors.accentColor }} />
                  </Button>
                ) : (
                  <Button className={classes.boxLogin} onClick={loginRedirect}>
                    <AccountCircle className={classes.loginIcon} />
                    <Typography className={classes.textButton}>
                      ENTRAR COM GOV.BR
                    </Typography>
                  </Button>
                )}
              </>
            )}
          </Box>
        </Box>
        {/* Desktop Navigation */}
        <Box className={classes.navBarLinks}>
          {/* links */}
          <Box className={classes.linksBox}>
            {navs.map((nav, index) => (
              <Links
                key={index.toString()}
                label={nav.nome}
                list={nav.list}
                route={nav.route_name}
                actionPage={nav.actionPage}
              />
            ))}
          </Box>
          {/* radio */}
          <Box
            className={classes.boxIcon}
            style={{ flexWrap: !matches ? 'wrap' : 'nowrap' }}
          >
            <Box className={classes.boxRadio} onClick={() => handlePlayer()}>
              <PlayerComponent
                handlePlay={handlePlayer}
                isPlaying={isPlaying}
              />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '3px 8px',
                }}
              >
                <Typography className={classes.textTitleRadio}>
                  OUÇA AO VIVO - A RÁDIO DO RIO - 94 FM
                </Typography>
                <Typography className={classes.textSubTitleRadio}>
                  RÁDIO ROQUETTE PINTO
                </Typography>
              </div>
            </Box>
            {renderMenus()}
            {!matches && (
              <Box display="flex" flex-direction="row" alignItems="center">
                {loading ? (
                  <CircularProgress
                    style={{ width: 25, height: 25 }}
                    color="primary"
                  />
                ) : (
                  <>
                    {userData ? (
                      <Button onClick={(e): void => handleClick(e, 'user')}>
                        <Avatar
                          src={avatarUser || null}
                          alt={getInitialsFromName(userData.nome || '')}
                          className={classes.avatar}
                        />
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                        >
                          <Typography className={classes.textName}>
                            {matchesMobile
                              ? nameSplitTwo(userData?.nome?.toLowerCase())
                              : nameSplitOne(userData?.nome?.toLowerCase())}
                          </Typography>
                          <Typography
                            color="primary"
                            className={classes.textCpf}
                          >
                            {cpfMask(userData.cpf)}
                          </Typography>
                        </Box>
                        <ExpandMore style={{ color: colors.accentColor }} />
                      </Button>
                    ) : (
                      <Button
                        className={classes.boxLogin}
                        onClick={loginRedirect}
                      >
                        <AccountCircle className={classes.loginIcon} />
                        <Typography className={classes.textButton}>
                          ENTRAR COM GOV.BR
                        </Typography>
                      </Button>
                    )}
                  </>
                )}
              </Box>
            )}
            {/* redes social */}
            <Box minWidth={270}>
              {iconsHeader && (
                <>
                  <span className={classes.dividerWhite}>|</span>
                  {iconsHeader.map((icon) => (
                    <IconButton
                      key={`${icon.titulo}-key`}
                      href={icon.url}
                      target="_blank"
                      aria-label={`${icon.titulo} (abre em nova aba)`}
                    >
                      <img
                        width="25px"
                        height="25px"
                        src={icon.url_imagem}
                        alt=""
                        loading="lazy"
                      />
                    </IconButton>
                  ))}
                </>
              )}
            </Box>
          </Box>

          <Box display="flex" flex-direction="row" alignItems="center">
            {loading ? (
              <CircularProgress
                style={{ width: 25, height: 25 }}
                color="primary"
              />
            ) : (
              <>
                {userData ? (
                  <Button onClick={(e): void => handleClick(e, 'user')}>
                    <Avatar
                      src={avatarUser || null}
                      alt={getInitialsFromName(userData.nome || '')}
                      className={classes.avatar}
                    />
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                    >
                      <Typography className={classes.textName}>
                        {matchesMobile
                          ? nameSplitTwo(userData?.nome?.toLowerCase())
                          : nameSplitOne(userData?.nome?.toLowerCase())}
                      </Typography>
                      <Typography color="primary" className={classes.textCpf}>
                        {cpfMask(userData.cpf)}
                      </Typography>
                    </Box>
                    <ExpandMore style={{ color: colors.accentColor }} />
                  </Button>
                ) : (
                  <Button className={classes.boxLogin} onClick={loginRedirect}>
                    <AccountCircle className={classes.loginIcon} />
                    <Typography className={classes.textButton}>
                      ENTRAR COM GOV.BR
                    </Typography>
                  </Button>
                )}
              </>
            )}
          </Box>
        </Box>
      </Box>
      <Box>
        <Suspense fallback="">
          <DrawerMenu
            navigationList={navs}
            isOpen={openDrawerNav}
            handleOpenDrawerNav={handleOpenDrawerMenu}
          />
        </Suspense>
        <Suspense fallback="">
          <QuickAccessDrawer
            icons={iconsHeader}
            links={linksHeader}
            isOpen={openDrawerQuickAccess}
            handleOpenDrawerQuickAccess={handleOpenDrawerQuickAccess}
          />
        </Suspense>
      </Box>
      <Suspense fallback="">
        <AlertDataComplements
          handleClose={() => setOpenModalComplements(false)}
          open={openModalComplements}
        />
      </Suspense>
    </>
  )
}
